import React from "react";
import ManageAssessment from "../Assessment/ManageAssessment";
import { ASSESSMENT_TYPES } from "../Assessment/assessmentType";

// Exams and Unit Tests share one screen; only the type differs.
const ManageAssignment = () => (
  <ManageAssessment type={ASSESSMENT_TYPES.unit_test} />
);

export default ManageAssignment;
